import { cn } from '@/shared/lib/cn';
import { usePrefsStore } from '@/entities/preferences/model/prefsStore';
import { NavMenu } from '../navMenu/NavMenu';
import { RailMenu } from '../navMenu/RailMenu';
import type { ReactNode } from 'react';

/** Masaüstü: sol menü (280px) — daraltıldığında ikon rayına düşer. */
export function SidebarLayout({ children }: { children: ReactNode }) {
  const collapsed = usePrefsStore((s) => s.prefs.sidebarCollapsed);
  return (
    <div className="flex min-h-0 flex-1 overflow-hidden">
      <aside
        className={cn(
          'border-border bg-bg-elevated flex min-h-0 shrink-0 flex-col overflow-hidden border-r transition-[width] duration-200',
          collapsed ? 'w-14' : 'w-72',
        )}
      >
        {collapsed ? <RailMenu /> : <NavMenu />}
      </aside>
      <main className="flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden">{children}</main>
    </div>
  );
}
